<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true" @change="initPage">
            </el-date-picker>
          </el-form-item>
<!--          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('积分统计')">导出</el-button> -->
          <el-radio-group v-model="form.type" size="small" @change="initPage">
            <el-radio-button label="1">物业总公司</el-radio-button>
            <el-radio-button label="2">物业分公司</el-radio-button>
            <el-radio-button label="3">项目部</el-radio-button>
            <el-radio-button label="4">站点</el-radio-button>
          </el-radio-group>
        </el-form>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-item">
        <div class="chart-item-tit">投递重量排名</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_AREAOPERATESTATISTICS:EXPORT'">
          <el-button class="chart-export" size="small" @click="exportChart('物业经营出入库统计')">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="deliveryChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-tit">出库重量排名</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_AREAOPERATESTATISTICS:EXPORT'">
          <el-button class="chart-export" size="small" @click="exportChart('物业经营出入库统计')">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="outboundChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../statisticalAnalysis/mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        type: '1'
      },
      communityOptions: [],
      siteOptions: [],
      chartEle: {
        totalChart: null,
        consumeChart: null,
        payChart: null
      }
    }
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.propertyStatisticalDeliveryOutbound()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          type: '1'
        }
      }
      this.initPage()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalProperty/propertyStatisticalDeliveryOutboundImport',
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 统计
    propertyStatisticalDeliveryOutbound() {
      this.$api.propertyStatistics.outbound.propertyStatisticalDeliveryOutbound(this.form).then(res => {
        this.$nextTick(() => {
          this.initDeliveryChart(res.data.deliveryList ? res.data.deliveryList : [])
          this.initOutboundChart(res.data.outboundList ? res.data.outboundList : [])
        })
      })
    },
    initDeliveryChart(data) {
      this.chartEle.consumeChart = this.$echarts.init(document.getElementById('deliveryChart'))
      const xNames = []; const y1Names = []
      for (const item of data) {
        xNames.push(item.name)
        y1Names.push(item.weight)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}'
        },
        grid: {
          left: '3%',
          bottom: 0,
          top: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: xNames
        },
        color: this.form.type === '1' ? ['#3373ca'] : ['#98c58c'],
        series: [{
          name: '2011',
          type: 'bar',
          data: y1Names
        }]
      }
      this.chartEle.consumeChart.setOption(option)
    },
    initOutboundChart(data) {
      this.chartEle.consumeChart = this.$echarts.init(document.getElementById('outboundChart'))
      const xNames = []; const y1Names = []
      for (const item of data) {
        xNames.push(item.name)
        y1Names.push(item.weight)
      }
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}: {c}'
        },
        grid: {
          left: '3%',
          bottom: 0,
          top: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: xNames
        },
        color: ['#FF6633'],
        series: [{
          name: '2011',
          type: 'bar',
          data: y1Names
        }]
      }
      this.chartEle.consumeChart.setOption(option)
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    }
  }
}
</script>
